import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { builderPathSetDirectionAction } from '../../../../redux/slices/oldBuilder';
import {
  PathDirectionKey,
  PathModeKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { builderSelectedOptionsSelector } from '../../../../redux/selectors/builder';
import { assertCondition } from '../../../../utils/types';
import BuilderEnumSelect from '../../../../components/Builder/BuilderFields/BuilderEnumSelect';

const directionOptions = [
  {
    key: PathDirectionKey.Forward,
    name: 'Forward',
    tooltip: {
      content: 'Move from a specific event to an end event(s).',
    },
  },
  {
    key: PathDirectionKey.Backward,
    name: 'Backward',
    tooltip: {
      content: 'Back into an end event and see all the paths leading up.',
    },
  },
];

const PathDirection = () => {
  const dispatch = useAppDispatch();

  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );
  const direction = useAppSelector(({ builder }) => builder.direction);

  assertCondition(selectedOptions?.type === QueryType.Path);

  const { mode } = selectedOptions;

  const directionDisabled = mode === PathModeKey.TopPaths;

  const handleChange = (value: PathDirectionKey) => {
    dispatch(
      builderPathSetDirectionAction({
        direction: value,
      }),
    );
  };

  return (
    <BuilderEnumSelect
      label="Direction"
      enumOptions={directionOptions}
      selectedOption={direction || null}
      onChange={handleChange}
      disabled={directionDisabled}
    />
  );
};

export default PathDirection;
